import * as React from 'react';

// Props
interface ISvgGridProps {
    width?: string;
    height?: string;
}

// Component
export class SvgGrid extends React.Component<ISvgGridProps, {}> {
    static get defaultProps(): ISvgGridProps {
        return {
            width: '100%',
            height: '100%',
        };
    }

    public render() {
        return (
            <svg
                width={this.props.width}
                height={this.props.height}
                viewBox="0 0 28 28"
                version="1.1"
                spacing="preserve"
                style={{
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    strokeLineJoin: 'round',
                    strokeMiterLimit: 2,
                }}
            >
                <g transform="matrix(0.736842,0,0,0.736842,0,0)">
                    <g transform="matrix(1.35714,0,0,1.35714,0,0)">
                        <path d="M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" />
                    </g>
                    <g transform="matrix(1.35714,0,0,1.35714,0,13.5714)">
                        <path d="M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" />
                    </g>
                    <g transform="matrix(1.35714,0,0,1.35714,0,27.1429)">
                        <path d="M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" />
                    </g>
                    <g transform="matrix(1.35714,0,0,1.35714,13.5714,0)">
                        <path d="M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" />
                    </g>
                    <g transform="matrix(1.35714,0,0,1.35714,13.5714,13.5714)">
                        <path d="M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" />
                    </g>
                    <g transform="matrix(1.35714,0,0,1.35714,13.5714,27.1429)">
                        <path d="M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" />
                    </g>
                    <g transform="matrix(1.35714,0,0,1.35714,27.1429,0)">
                        <path d="M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" />
                    </g>
                    <g transform="matrix(1.35714,0,0,1.35714,27.1429,13.5714)">
                        <path d="M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" />
                    </g>
                    <g transform="matrix(1.35714,0,0,1.35714,27.1429,27.1429)">
                        <path d="M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" />
                    </g>
                </g>
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/svg/SvgGrid.tsx